import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Text } from '@uhg-abyss/web/ui/Text';

export const StyledDrawer = styled(Drawer, {
  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    '@media (max-width: 464px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '.abyss-modal-close-button': {
    '@media (max-width: 464px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-base-body': {
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
});

export const SmartChoiceCard = styled('div', {
  marginTop: 0,
  borderWidth: '0.5px',
  borderColor: '#CBCCCD',
  borderStyle: 'solid',
  width: '100%',
  borderRadius: '8px',
  padding: '16px',
  backgroundColor: 'white',
  '@media (max-width: 984px)': {
    width: '100%',
    alignItems: 'flex-start',
  },
  '.desc-text': {
    color: '$core.color.neutral.80',
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: '$core.color.neutral.100',
    lineHeight: '18px',
    '@media (max-width: 744px)': {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '18px',
    },
  },
  '.desc-text-l1': {
    color: '$core.color.neutral.80',
    fontSize: '16px',
    fontWeight: 400,
    fontFamily: '$core.color.neutral.100',
    lineHeight: '20px',
    '@media (max-width: 744px)': {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '20px',
    },
  },
  '.abyss-card-root': {
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    paddingTop: '$md',
    paddingBottom: '$md',
    display: 'flex',
    '@media (max-width: 744px)': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
});

export const BreakDownContainer = styled('div', {
  borderWidth: '0.5px',
  borderColor: '#CBCCCD',
  borderStyle: 'solid',
  width: '100%',
  borderRadius: '8px',
  padding: '16px 32px',
  '@media (max-width: 744px)': {
    alignItems: 'flex-start',
    padding: '16px',
  },
});

export const RightContainer = styled('div', {
  marginLeft: '8px',
  display: 'flex',
  flexDirection: 'column',
  '.smart-choice-text': {
    fontFamily: '$core.color.neutral.100',
    lineHeight: '32px',
    color: '$core.color.neutral.90 !important',
    fontWeight: 700,
  },
});

export const BreakDownValue = styled(Text, {
  fontSize: '14px !important',
  fontWeight: 700,
  paddingTop: '2px',
  paddingBottom: '2px',
  paddingLeft: '8px',
  paddingRight: '8px',
  borderRadius: '4px',
  fontFamily: '$core.color.neutral.100',
  lineHeight: '18px',
});

export const PercentageBox = styled('div', {
  width: '92px',
  height: '68px',
  backgroundColor: '#007000',
  borderRadius: '8px',
  justifyContent: 'center',
  display: 'flex',
  alignItems: 'center',
  '@media (max-width: 744px)': {
    width: '76px',
    height: '60px',
  },
});

export const PercentageText = styled(Text, {
  color: 'white',
  fontSize: '28px !important',
  fontWeight: 700,
  fontFamily: '$core.color.neutral.100',
  lineHeight: '36px !important',
  '@media (max-width: 744px)': {
    fontSize: '22px !important',
    lineHeight: '28px !important',
  },
});

export const BreakDownValueContainer = styled('div', {
  marginTop: '4px',
  marginBottom: '12px',
});

export const BreakDownTitle = styled(Text, {
  fontFamily: '$core.color.neutral.100',
  lineHeight: '18px',
});

export const smartChoiceLinkStyle = (isMobileScreen, isWidget) => ({
  fontWeight: '600',
  marginRight: isWidget ? '10px' : '0px',
  '& .abyss-insert-element-after': {
    alignItems: 'flex-end',
    '& svg': { fill: '#C40000' },
    marginLeft: isMobileScreen ? '-20px' : '-8px',
  },
  '&:hover::before': { display: 'none' },
});
